import { render, staticRenderFns } from "./CrudLinkDomainProductGroup.vue?vue&type=template&id=80b4018a&scoped=true"
import script from "./CrudLinkDomainProductGroup.vue?vue&type=script&lang=js"
export * from "./CrudLinkDomainProductGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b4018a",
  null
  
)

export default component.exports